import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';
import { AppInitService } from '../../services/app-init.service';
import { LoaderService } from '../../services/loader.service';
// import env from '../../../../assets/config/env.json';
@Component({
  selector: 'app-pre-login',
  templateUrl: './pre-login.component.html',
  styleUrls: ['./pre-login.component.scss'],
})
export class PreLoginComponent implements OnInit {
  isProfileComponent = true;
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 2000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = true;
  headerLogoId = '';
  loginLogoId = '';
  headerLogoPath = '';
  loginLogoPath = '';
  imagesource = './assets/images/login-page-logo.png';
  projectId;
  isRefresh = false;
  showEnvDetails: boolean;
  constructor(
    private http: HttpClient,
    private appInitService: AppInitService,
    public loderService: LoaderService
  ) {
    console.log();
  }
  // urlval = {};

  ngOnInit(): void {
    this.showEnvDetails = this.appInitService?.appConfig?.showEnvDetails;
    //this.loginLogoId = JSON.parse(localStorage.getItem('loginLogoId'));
    if (this.appInitService.appConfig.authType !== 'oauth2') {
      //  this.getLogoId();
      this.imagesource = this.appInitService?.imagesource;
    }
  }
  // getLogoId() {
  //   this.projectId = 8;
  //   if (this.projectId) {
  //     let params = new HttpParams();
  //     params = params.append('projectId', this.projectId);
  //     this.http
  //       .get('/admin/project-config-details', { params: params })
  //       .subscribe((res) => {
  //         const restemp: any = res;
  //         this.loginLogoId = restemp?.data?.loginAttachId;
  //         if (restemp?.data?.docFileType) {
  //           this.imagesource =
  //             'data:image/' +
  //             restemp?.data?.docFileType +
  //             ';base64,' +
  //             restemp?.data?.fileBytes;
  //         }
  //         this.headerLogoId = restemp?.data?.headerAttachId;
  //         localStorage.setItem('headerLogoId', this.headerLogoId);
  //         localStorage.setItem('loginLogoId', this.loginLogoId);
  //       });
  //   }
  // }
  onFinalPath(event) {}
}
